namespace Areas.Dialogs {
    "use strict";

    let vendorPortalVendorId: number;

    export class CreateContractVendorLinkDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void,
            parameters: any = null,
            rootElementId: string = "dialog") {
            super("CreateContractVendorLink",
                closeHandler,
                parameters, () => {
                    vendorPortalVendorId = parameters.dataId;
            },
                rootElementId);
        }

        protected ok = (e: any) => {
            const dataGrid = $("#ContractVendorLinkLookupGrid").dxDataGrid("instance");
            const selectedRows: any = dataGrid.getSelectedRowsData();

            if (selectedRows[0] == null) {                                                                                                                                                            DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
            } else {
                const contractVendorId = selectedRows[0].vendorId;

                const values = { vendorPortalVendorId, contractVendorId }
                sendRequest("/Reviewers/ContractLink/CreateContractVendorLink", JSON.stringify(values), "POST");

                ;
            }
            }
        }
    }